export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["SET_VALUE"] = "SET_VALUE";
    ActionTypes["SET_OPTIONS_ARE_OPEN"] = "SET_OPTIONS_ARE_OPEN";
    ActionTypes["SET_FOCUSED"] = "SET_FOCUSED";
    ActionTypes["SET_CURRENT_OPTION"] = "SET_CURRENT_OPTION";
})(ActionTypes || (ActionTypes = {}));
